import jwtDecode from "jwt-decode";
import log from "../../commons/services/log";
import http from "../../commons/services/http";
import handleUserFlagsEvents from "./userFlagsEvents";

let tokenKey   = '';
let logout_url = '';
let User       = null;

/**
 * PUBLIC
 * @param {*} app_name 
 */
function setTokenKeyName(app_name) {
  tokenKey = app_name;
}

/**
 * PUBLIC
 * @param {*} app_name 
 */
function setOauth(i_base_logout) {
  logout_url = i_base_logout + '?client_id=demonhead.central';
}

/****************** JWT *****************/
function getJwt() {
  return localStorage.getItem(tokenKey);
}

function removeJwt() {
  return localStorage.removeItem(tokenKey);
}

function localLogout() {
  removeJwt();
  window.location.href = logout_url;
}

function logoutWithoutRedirect() {
  removeJwt();
}

function getCurrentUser() {
  if(User){
    log.debug('(1)USER IS ',User);
    if(User.flags && User.flags.length){//we have a flag! We will act upon flag 0, once that flag is handled, it should be deleted, then the new flag 0 will be acted upon
      handleUserFlagsEvents(User.flags[0]);
    }
    return User;
  }

  try {
    const JWT = getJwt();
    if (JWT) {
      http.setJwt(JWT); //Incase this is first load from local storage
      const AccessToken = jwtDecode(JWT);
      log.debug('ACCESS TOKEN PARSED:',AccessToken);

      //JWT always coming from DemonHead, even if initial JWT came from Opal, DemonHead will normalize it
      //and load all user info. Opal is used just to auth.
      if(AccessToken.user){
        User = AccessToken.user;
      }else{
        throw Error('Bad access token');
      }
      log.debug('(2)USER IS ',User);
      return User;
    }
  } catch (ex) {
    log.fatal("EXCEPTION!", ex);
  }
  return null;
}

const auth = {
  setTokenKeyName,
  setOauth,
  localLogout,
  getCurrentUser,
  logoutWithoutRedirect
};

export default auth;
